import { mPerLat, mPerLon } from '../lib/geo';
import { useEffect, useState } from 'react';
import { planRound, lastFix } from '../lib/route';
import { saveRound, clearRound } from './LegList';
import { toast } from 'sonner';
import { splitHint } from '../lib/routeSplitText';


export const dist = (a, b) => Math.hypot((a.lat - b.lat) * mPerLat(a.lat), (a.lon - b.lon) * mPerLon(a.lat));
export const fmtDist = (d) => (d < 1000 ? `${Math.round(d)} m` : `${(d / 1000).toFixed(1).replace('.', ',')} km`);

export function usePos(on) {
  const [p, setP] = useState(null);
  useEffect(() => {
    if (!on || !navigator.geolocation) return undefined;
    const id = navigator.geolocation.watchPosition((x) => setP({ lat: x.coords.latitude, lon: x.coords.longitude, acc: x.coords.accuracy }), () => {}, { enableHighAccuracy: true, maximumAge: 2000 });
    return () => navigator.geolocation.clearWatch(id);
  }, [on]);
  return p;
}

export function ModePick({ t, v, onChange, pre }) {
  return (
    <div className="lp-mode" data-testid={`${pre}-mode`}>
      <div className="lg-durs">
        <button type="button" className={`chip seg ${v.mode === 'perm' ? 'on' : ''}`} data-testid={`${pre}-mode-perm`} onClick={() => onChange({ ...v, mode: 'perm' })}>{t.lpPerm}</button>
        <button type="button" className={`chip seg ${v.mode === 'lift' ? 'on' : ''}`} data-testid={`${pre}-mode-lift`} onClick={() => onChange({ ...v, mode: 'lift' })}>{t.lpLift}</button>
      </div>
      {v.mode === 'lift' && (
        <div className="lg-durs">
          {[1, 2, 3, 7].map((x) => <button key={x} type="button" className={`chip seg ${v.days === x ? 'on' : ''}`} data-testid={`${pre}-days-${x}`} onClick={() => onChange({ ...v, days: x })}>{x} {t.lgDays}</button>)}
          <input className="lp-days" inputMode="numeric" data-testid={`${pre}-days-input`} aria-label={t.lgDays} value={v.days} onChange={(e) => onChange({ ...v, days: Math.max(1, Math.min(60, parseInt(e.target.value, 10) || 1)) })} />
        </div>
      )}
    </div>
  );
}

// where to put the logger: own GPS position or the map crosshair
export function PosPick({ t, pos, src, setSrc, pre }) {
  return (
    <div className="lg-durs lp-src" data-testid={`${pre}-src`}>
      <button type="button" disabled={!pos} className={`chip seg ${src === 'gps' ? 'on' : ''}`} data-testid={`${pre}-src-gps`} onClick={() => setSrc('gps')}>📍 {t.lcPosGps}{pos?.acc ? ` ±${Math.round(pos.acc)} m` : ''}</button>
      <button type="button" className={`chip seg ${src === 'cross' ? 'on' : ''}`} data-testid={`${pre}-src-cross`} onClick={() => setSrc('cross')}>✚ {t.lcPosCross}</button>
    </div>
  );
}

export const pickAt = (src, pos, mapRef) => {
  if (src === 'gps' && pos) return { lat: pos.lat, lon: pos.lon };
  const c = mapRef.current.getCenter();
  return { lat: c.lat, lon: c.lng ?? c.lon };
};

// deployment round: sort open plan entries from the last GPS fix; one leg opens Google Maps at once (start = "my location"),
// several legs (more than 10 stops) are returned as buttons with a hint
// legs for the deploy round when its panel is not mounted yet (card button opens the plan afterwards)
export function startRound(plan, setPlan, keep) {
  const open = plan.filter((p) => !p.doneAt);
  if (!open.length) return [];
  const here = lastFix();
  const { ord, legs, km } = planRound(here, open, keep);
  if (!keep) setPlan([...plan.filter((p) => p.doneAt), ...ord.filter((p) => !p.back)]);
  if (legs.length === 1) { window.open(legs[0].url, '_blank'); clearRound('lp'); } else { saveRound('lp', legs, { km, n: open.length }); toast.info(splitHint(open.length, legs.length), { duration: 10000 }); }
  return legs;
}
export const openPlanTab = (tab) => window.dispatchEvent(new CustomEvent('giss-lgplan-open', { detail: { tab } }));
